import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoganpatipuletaxi() {



const cardData = {
  keyword: " Pune to Ganpatipule Taxi  ",

"headingDescription": "SRS Cab Service offers Pune to Ganpatipule Taxi, providing a comfortable, safe, and scenic travel experience for families, pilgrims, and leisure travelers. Our well-maintained vehicles, experienced drivers, and timely pickups ensure a smooth journey from Pune to the beautiful coastal town of Ganpatipule. Ideal for beach trips, temple visits, and weekend getaways, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a hassle-free and enjoyable travel experience.",
"topPlaces": [
  {
    "title": "Ganpatipule Temple",
    "description": "Ganpatipule Temple is a famous self-originated Lord Ganesha temple located on the beach. Travelers using SRS Cab Service from Pune often visit this sacred temple to seek blessings and enjoy its peaceful coastal surroundings."
  },
  {
    "title": "Ganpatipule Beach",
    "description": "Ganpatipule Beach is known for its clean shoreline and scenic beauty. Visitors using SRS Cab Service often relax here, enjoy the sea breeze, and capture beautiful sunset views."
  },
  {
    "title": "Prachin Konkan Museum",
    "description": "Prachin Konkan Museum showcases traditional Konkan life and culture through life-size exhibits. Travelers using SRS Cab Service often explore this museum to learn about the region’s heritage."
  },
  {
    "title": "Jaigad Fort",
    "description": "Jaigad Fort is a historic sea fort offering panoramic views of the Arabian Sea. Visitors using SRS Cab Service often include this site for sightseeing and photography."
  },
  {
    "title": "Jaigad Lighthouse",
    "description": "Jaigad Lighthouse provides stunning coastal views and is a great spot for photography. Travelers using SRS Cab Service often visit this attraction along with Jaigad Fort."
  },
  {
    "title": "Aare Ware Beach",
    "description": "Aare Ware Beach is a quiet and less crowded beach known for its natural beauty. Visitors using SRS Cab Service often stop here for a peaceful and relaxing experience."
  },
  {
    "title": "Velneshwar Temple",
    "description": "Velneshwar Temple is an ancient Shiva temple located near a serene beach. Travelers using SRS Cab Service often visit for both spiritual and scenic experiences."
  },
  {
    "title": "Hedvi Ganesh Temple",
    "description": "Hedvi Ganesh Temple is famous for its Dashabhuja (ten-armed) Ganesha idol. Visitors using SRS Cab Service often include this temple in their pilgrimage itinerary."
  },
  {
    "title": "Malvan Marine Sanctuary",
    "description": "Malvan Marine Sanctuary is known for its rich marine life and water activities. Travelers using SRS Cab Service often explore this destination for snorkeling and coastal adventure."
  },
  {
    "title": "Ratnagiri Town",
    "description": "Ratnagiri Town is known for its beaches, forts, and Alphonso mangoes. Visitors using SRS Cab Service often explore this nearby town for local culture and sightseeing."
  }
],



services: [
{
name: "Pune to Ganpatipule Taxi Fare",
description: "Pune to Ganpatipule taxi fare provides detailed pricing for travel planning. Customers can check fare estimates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with taxi fare services."
},
{
name: "Pune to Ganpatipule Cab Charges",
description: "Pune to Ganpatipule cab charges offer clear pricing for travelers. Customers can check charges before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent charges."
},
{
name: "Pune to Ganpatipule Taxi Booking",
description: "Pune to Ganpatipule taxi booking provides quick and easy reservation options. Customers can book taxis online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily from Pune."
},
{
name: "Pune to Ganpatipule Car Rental",
description: "Pune to Ganpatipule car rental offers flexible vehicle options for long-distance travel. Customers can rent cars for family and vacation trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Rent cars easily from Pune."
},
{
name: "Pune to Ganpatipule Chauffeur-Driven Cabs",
description: "Pune to Ganpatipule chauffeur-driven cabs provide premium travel experience for customers. Users can enjoy professional driver services. Comfortable vehicles enhance travel experience. Safe journeys are ensured. Flexible booking options are available. Travel easily with chauffeur-driven cab services."
},
{
name: "Pune to Ganpatipule Taxi Rates",
description: "Pune to Ganpatipule taxi rates provide clear pricing details for travelers. Customers can compare rates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent rates."
},
{
name: "Pune to Ganpatipule Cab Pricing",
description: "Pune to Ganpatipule cab pricing offers detailed cost breakdown for trips. Customers can compare pricing before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent pricing."
},
{
name: "Pune to Ganpatipule Taxi Fare Calculator",
description: "Pune to Ganpatipule taxi fare calculator helps customers estimate travel costs easily. Users can calculate fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Plan trips easily with fare calculator tools."
},
{
name: "Pune to Ganpatipule Private Car Hire",
description: "Pune to Ganpatipule private car hire offers personalized travel for families and groups. Customers can hire vehicles for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with private car hire services."
},
{
name: "Pune to Ganpatipule Cab Cost",
description: "Pune to Ganpatipule cab cost provides estimated pricing for travelers. Customers can check trip cost before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab cost services."
},
{
name: "Pune to Ganpatipule Taxi Service Charges",
description: "Pune to Ganpatipule taxi service charges offer clear pricing for transportation. Customers can check charges before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent charges."
},
{
name: "Pune to Ganpatipule Taxi",
description: "Pune to Ganpatipule taxi provides convenient travel for beach trips. Customers can book taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab from Pune to Ganpatipule",
description: "Cab from Pune to Ganpatipule offers reliable long-distance travel for vacations. Customers can book cabs for beach and temple visits. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Ganpatipule Cab Booking",
description: "Pune to Ganpatipule cab booking provides easy reservation options for travelers. Customers can book cabs online or via apps. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily from Pune."
},
{
name: "Pune to Ganpatipule Cab Service",
description: "Pune to Ganpatipule cab service offers dependable transportation for coastal travel. Customers can book cabs for leisure trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Ganpatipule Innova Crysta",
description: "Pune to Ganpatipule Innova Crysta offers premium SUV travel for comfort. Customers can enjoy spacious seating and luggage space. Professional drivers ensure safe journeys. Ideal for family travel. Transparent pricing ensures value for money. Travel comfortably with Innova Crysta."
},
{
name: "Pune to Ganpatipule Innova Cab",
description: "Pune to Ganpatipule Innova cab provides comfortable travel for long-distance journeys. Customers can book vehicles for family trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Innova cab services."
},
{
name: "Pune to Ganpatipule Tempo Traveller",
description: "Pune to Ganpatipule tempo traveller offers group travel solutions for vacations. Customers can book spacious vehicles for family trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "17 Seater Tempo Traveller on Rent in Pune",
description: "17 seater tempo traveller on rent in Pune offers comfortable group travel for tours. Customers can book vehicles for family and corporate trips. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller rentals."
},
{
name: "Tempo Traveller on Rent in Pune",
description: "Tempo traveller on rent in Pune provides reliable transportation for group travel. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Pune to Ganpatipule Beach Cab Service",
description: "Pune to Ganpatipule beach cab service offers convenient travel for coastal vacations. Customers can book cabs for beach trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily to Ganpatipule beach with cab services."
},
{
name: "Pune to Ganpatipule Taxi Service",
description: "Pune to Ganpatipule taxi service provides dependable transportation for long-distance travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
}
],

tableData: [
["Pune to Ganpatipule Taxi Fare","Pune to Ganpatipule Cab Charges"],
["Pune to Ganpatipule Taxi Booking","Pune to Ganpatipule Car Rental"],
["Pune to Ganpatipule Chauffeur-Driven Cabs","Pune to Ganpatipule Taxi Rates"],
["Pune to Ganpatipule Cab Pricing","Pune to Ganpatipule Taxi Fare Calculator"],
["Pune to Ganpatipule Private Car Hire","Pune to Ganpatipule Cab Cost"],
["Pune to Ganpatipule Taxi Service Charges","Pune to Ganpatipule Taxi"],
["Cab from Pune to Ganpatipule","Pune to Ganpatipule Cab Booking"],
["Pune to Ganpatipule Cab Service","Pune to Ganpatipule Innova Crysta"],
["Pune to Ganpatipule Innova Cab","Pune to Ganpatipule Tempo Traveller"],
["17 Seater Tempo Traveller on Rent in Pune","Tempo Traveller on Rent in Pune"],
["Pune to Ganpatipule Beach Cab Service","Pune to Ganpatipule Taxi Service"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Konkan Route Drivers",
    WhyChoosedescription: "SRS Cab Service provides skilled drivers familiar with Pune to Ganpatipule coastal and ghat routes, ensuring safe driving and a smooth travel experience."
  },
  {
    WhyChooseheading: "Affordable Pune to Ganpatipule Taxi Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune to Ganpatipule taxi services with transparent pricing. Customers receive complete fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Taxi Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Ganpatipule taxi bookings, making it convenient for weekend trips, holiday travel, and flexible departure timings."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles for Long Travel",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles suitable for long-distance coastal journeys, ensuring a relaxing ride."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We provide one-way taxi service, round-trip bookings, and customized travel plans for Pune to Ganpatipule trips and Konkan tours."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for couples, families, and group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We offer convenient pickup from homes, hotels, offices, and Pune Airport across all major areas including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Konkan Taxi Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Ganpatipule taxi bookings due to reliable service, experienced drivers, and comfortable travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Ganpatipule taxi service?", answer: "Yes, SRS Cab Service offers reliable taxi services from Pune to Ganpatipule." },
  { question: "How far is Ganpatipule from Pune?", answer: "The distance between Pune and Ganpatipule is approximately 300 km and the journey takes around 6 to 8 hours depending on route and traffic." },
  { question: "Is Pune to Ganpatipule taxi service available 24 hours?", answer: "Yes, our taxi service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for Ganpatipule trip?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way taxi from Pune to Ganpatipule?", answer: "Yes, we provide both one-way and round-trip taxi services." },
  { question: "Do you provide Konkan tour packages?", answer: "Yes, we offer customized Konkan tour packages including Ganpatipule, Ratnagiri, and nearby beaches." },
  { question: "Are vehicles suitable for ghat travel?", answer: "Yes, all vehicles are well-maintained and suitable for ghat and coastal road travel." },
  { question: "Can I book the taxi online?", answer: "Yes, you can easily book Pune to Ganpatipule taxi service online or via phone." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prakash Deshmukh",
    feedback:
      "Booked SRS Cab Service for Ganpatipule trip. Very smooth journey and driver handled ghat roads perfectly.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Ritu Sharma",
    feedback:
      "Best Pune to Ganpatipule taxi service. Comfortable ride and perfect for family vacation.",
    rating: 5
  }
];






























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ganpatipule Taxi | SRS Cab",
  "description": "SRS Cab provides Pune to Ganpatipule taxi services including one-way and round trips, cab booking, car rentals, and chauffeur-driven cabs. Book Innova Crysta, tempo traveller, and private cars for safe, comfortable, and affordable travel with 24x7 online booking and best fares.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Pune to Ganpatipule Taxi | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Ganpatipule taxi with SRS Cab. One-way, round trips, cab booking, car rentals, chauffeur-driven cabs, Innova Crysta, and tempo travellers. Safe, comfortable rides with 24x7 online booking and affordable fares." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/41.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoganpatipuletaxi;